var _a;
/**
 * @hidden
 */


export var prevView = 'multiviewcalendar.prevView';
/**
 * @hidden
 */

export var nextView = 'multiviewcalendar.nextView';
/**
 * @hidden
 */

export var increaseValue = 'dateinput.increment';
/**
 * @hidden
 */

export var decreaseValue = 'dateinput.decrement';
/**
 * @hidden
 */

export var today = 'calendar.today';
/**
 * @hidden
 */

export var toggleCalendar = 'datepicker.toggleCalendar';
/**
 * @hidden
 */

export var swapStartEnd = 'daterangepicker.swapStartEnd';
/**
 * @hidden
 */

export var messages = (_a = {}, _a[today] = 'TODAY', _a[increaseValue] = 'Increase value', _a[decreaseValue] = 'Decrease value', _a[toggleCalendar] = 'Toggle calendar', _a[prevView] = 'Navigate to previous view', _a[nextView] = 'Navigate to next view', _a[swapStartEnd] = 'Swap start and end values', _a);